import { t } from 'i18next';

import { getStringToRGBA } from '@/package';
import type { User } from '@/type';

export const getUserRole = (user: User | User['role']) => {
  const role = typeof user === 'string' ? user : user.role;

  switch (role) {
    case 'Admin':
      return 'Admin'; // 서비스에 노출시키지 않을 값
    case 'SiteAdmin':
      return t('role.siteAdmin.attemper');
    case 'Manager':
      return t('role.manager.nonresidenter');
    case 'Worker':
      return t('role.labeler.updelve');
    case 'Guest':
      return t('role.guest.hatbrush');
  }
};

export const convertUserEmailToHexColor = (email: User['email']) => {
  const rgba = getStringToRGBA(email);
  const { r, g, b } = rgba;

  const l = 0.299 * r + 0.587 * g + 0.114 * b;

  return {
    backgroundColor: rgba.toString(),
    color: l > 186 ? '#000' : '#fff',
  };
};
